import { render, staticRenderFns } from "./TefConfigTerminales.vue?vue&type=template&id=668ae1d5"
import script from "./TefConfigTerminales.vue?vue&type=script&lang=js"
export * from "./TefConfigTerminales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports